import apiClient from '@/services/rest-api-vsms/apiClient'

const baseEndpoint = '/banner-active'

export const get = async (_params) => {
  const response = await apiClient({
    method: 'GET',
    url: `${baseEndpoint}/company`,
    params: _params,
  })

  return response?.data
}

export const getBanners = async () => {
  const response = await apiClient({
    method: 'GET',
    url: baseEndpoint,
  })

  return response?.data
}
